<template>
  <div class="propertyEnterpriseInfo">
    <el-card>
      <div class="flexBox">
        <el-tabs @tab-click="handleClick" v-model="activeTabName">
          <el-tab-pane label="企业基本信息" name="0"></el-tab-pane>
          <el-tab-pane label="人员基本信息" name="1"></el-tab-pane>
        </el-tabs>
        <div class="jump-btn">
          <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
        </div>
      </div>
      <!-- 企业基本信息 -->
      <el-form v-show="tabIndex==0" :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws12" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="社会统一信用代码" prop="creditCode">
          <el-input v-model="ruleForm.creditCode" placeholder="请输入社会统一信用代码" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业名称" prop="enterpriseName">
          <el-input v-model="ruleForm.enterpriseName" placeholder="请输入企业名称" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业简称" prop="enterpriseSimpleName">
          <el-input v-model="ruleForm.enterpriseSimpleName" placeholder="请输入企业简称" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="注册地址" prop="logonAddress">
          <el-input v-model="ruleForm.logonAddress" placeholder="请输入注册地址" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="通讯地址" prop="communicationAddress">
          <el-input v-model="ruleForm.communicationAddress" placeholder="请输入通讯地址" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业法人名称" prop="legalPersonName">
          <el-input v-model="ruleForm.legalPersonName" placeholder="请输入企业法人名称" class="item-input" maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item label="法人证件类型" prop="legalPersonPapersType">
          <el-select v-model="ruleForm.legalPersonPapersType" placeholder="请选择">
            <el-option v-for="item in legalPersonPapersType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="法人证件号码" prop="legalPersonPapersNum">
          <el-input v-model="ruleForm.legalPersonPapersNum" placeholder="请输入法人证件号码" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="法人手机号码" prop="legalPersonPhoneNum">
          <el-input v-model="ruleForm.legalPersonPhoneNum" placeholder="请输入法人手机号码" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业网址" prop="enterpriseWebsite">
          <el-input v-model="ruleForm.enterpriseWebsite" placeholder="请输入企业网址" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="企业类型" prop="enterpriseType">
          <el-input v-model="ruleForm.enterpriseType" placeholder="请输入企业类型" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="联系人" prop="liaisonName">
          <el-input v-model="ruleForm.liaisonName" placeholder="请输入联系人" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="联系电话" prop="liaisonPhone">
          <el-input v-model="ruleForm.liaisonPhone" placeholder="请输入联系电话" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="电子信箱" prop="email">
          <el-input v-model="ruleForm.email" placeholder="请输入电子信箱" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="注册资本（万元）" prop="registerMoney">
          <el-input v-model="ruleForm.registerMoney" placeholder="请输入注册金额（万元）" class="item-input" type="number"
            maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item label="成立日期" prop="enterpriseDate">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.enterpriseDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="营业执照开始日期" prop="businessLicenseDate1">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
            v-model="ruleForm.businessLicenseDate1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="营业执照过期日期" prop="businessLicenseDate2">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
            v-model="ruleForm.businessLicenseDate2">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="所属行政区" prop="administrativeRegion">
          <el-select v-model="ruleForm.administrativeRegion" placeholder="请选择">
            <el-option v-for="item in administrativeRegion" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="邮政编码" prop="postalCode">
          <el-input v-model="ruleForm.postalCode" placeholder="请输入邮政编码" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="集团名称" prop="groupName">
          <el-input v-model="ruleForm.groupName" placeholder="请输入集团名称" class="item-input" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="外委公司总人数（人）" prop="outsourcingPeopleNum">
          <el-input v-model="ruleForm.outsourcingPeopleNum" placeholder="请输入外委公司总人数（人）" class="item-input" type="number"
            maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="服务项目人员总数（人）" prop="serviceItemsPeopleNum">
          <el-input v-model="ruleForm.serviceItemsPeopleNum" placeholder="请输入服务项目人员总数（人）" class="item-input"
            type="number" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item tem label="不服务项目人员总数（人）" prop="noServiceItemsPeopleNum">
          <el-input v-model="ruleForm.noServiceItemsPeopleNum" placeholder="请输入不服务项目人员总数（人）" class="item-input"
            type="number" maxlength="20">
          </el-input>
        </el-form-item>
        <el-form-item label="是否建立党组织" prop="hasParty">
          <el-select v-model="ruleForm.hasParty" placeholder="请选择">
            <el-option v-for="item in hasParty" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="党组织类型" prop="partyType"
          :rules="ruleForm.hasParty==1 ? rules.partyType : [{ required:false}]">
          <el-select v-model="ruleForm.partyType" placeholder="请选择">
            <el-option v-for="item in partyType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="党组织成立时间" prop="foundDate"
          :rules="ruleForm.hasParty==1 ? rules.foundDate : [{ required:false}]">
          <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.foundDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item tem label="党组织负责人" prop="leader"
          :rules="ruleForm.hasParty==1 ? rules.leader : [{ required:false}]">
          <el-input v-model="ruleForm.leader" placeholder="请输入党组织负责人" class="item-input" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item tem label="党员总数（人）" prop="partyMemberNum">
          <el-input v-model="ruleForm.partyMemberNum" placeholder="请输入党员总数（没有党员则填0）" class="item-input" type="number"
            maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="委员总数（人）" prop="committeeMemberNum"
          :rules="ruleForm.hasParty==1 ? rules.committeeMemberNum : [{ required:false}]">
          <el-input v-model="ruleForm.committeeMemberNum" placeholder="请输入委员总数" class="item-input" type="number"
            maxlength="15">
          </el-input>
        </el-form-item>
        <el-form-item tem label="经营范围" prop="businessScope">
          <el-input v-model="ruleForm.businessScope" placeholder="请输入经营范围" class="item-input" type="textarea"
            :autosize="{ minRows: 4}">
          </el-input>
        </el-form-item>
        <el-form-item tem label="备注" prop="remark">
          <el-input v-model="ruleForm.remark" placeholder="请输入备注" class="item-input" type="textarea"
            :autosize="{ minRows: 4}">
          </el-input>
        </el-form-item>
        <el-form-item label="营业执照" prop="businessLicensePhoto" ref="businessLicensePhoto">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="businessLicensePhotoList"
            @outputFile="getBusinessLicensePhoto" @removeFile="removeFile1"></upload-file>
        </el-form-item>
        <el-form-item label="法人身份证（正面）" prop="businessLicensePhotoIn" ref="businessLicensePhotoIn">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="businessLicensePhotoInList"
            @outputFile="getBusinessLicensePhotoIn" @removeFile="removeFile2"></upload-file>
        </el-form-item>
        <el-form-item label="法人身份证（背面）" prop="businessLicensePhotoOut" ref="businessLicensePhotoOut">
          <upload-file ref="uploading" :accept="accept" upTypes="1" :fileList="businessLicensePhotoOutList"
            @outputFile="getBusinessLicensePhotoOut" @removeFile="removeFile3"></upload-file>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
      <!-- 人员基本信息 -->
      <el-button v-show="tabIndex==1" type="primary" style="float:right;margin-bottom:10px;" @click="add">新增人员
      </el-button>
      <el-table v-show="tabIndex==1" :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="personName" label="人员姓名" align="center">
        </el-table-column>
        <el-table-column prop="personType" label="人员性质" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.personType == 1">法定代表人</span>
            <span v-if="scope.row.personType == 2">企业负责人</span>
            <span v-if="scope.row.personType == 3">其他管理人员</span>
          </template>
        </el-table-column>
        <el-table-column prop="personJob" label="职务" align="center">
        </el-table-column>
        <el-table-column prop="certificateNum" label="证件号码" align="center">
        </el-table-column>
        <el-table-column prop="personPhone" label="联系电话" align="center">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:propertyEnterpriseInfo
   *@Description:物业企业信息管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  import UploadFile from '../../components/upload_file.vue'
  export default {
    data() {
      return {
        // 企业基本信息
        accept: '.jpg, .jpeg, .png',
        tabIndex: 0, // tab栏下标
        activeTabName: '0', // tab默认值
        formId: '', // 表单id
        isDisabled: true, // 保存的可点击
        saveData: '',
        hasParty: this.$i18n.t('lang.hasParty'),
        partyType: this.$i18n.t('lang.partyType'),
        legalPersonPapersType: this.$i18n.t('lang.legalPersonPapersType'),
        administrativeRegion: this.$i18n.t('lang.administrativeRegion'),
        businessLicensePhotoList: [], // 营业执照文件集合
        businessLicensePhotoInList: [], // 法人身份证正面图片
        businessLicensePhotoOutList: [], // 法人身份证背面图片
        rules: {
          creditCode: [{
            required: true,
            message: '请输入社会统一信用代码',
            trigger: 'blur'
          }],
          enterpriseName: [{
            required: true,
            message: '请输入企业名称',
            trigger: 'blur'
          }],
          enterpriseSimpleName: [{
            required: true,
            message: '请输入企业简称',
            trigger: 'blur'
          }],
          legalPersonName: [{
            required: true,
            message: '请输入企业法人名称',
            trigger: 'blur'
          }],
          // legalPersonPapersType: [{
          //   required: true,
          //   message: '请选择法人证件类型',
          //   trigger: 'change'
          // }],
          // legalPersonPapersNum: [{
          //   required: true,
          //   message: '请输入法人证件号码',
          //   trigger: 'blur'
          // },
          // { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          //   message: '请输入正确的身份证号码',
          //   trigger: 'blur'
          // }],
          // legalPersonPhoneNum: [{
          //   required: true,
          //   message: '请输入法人手机号码',
          //   trigger: 'blur'
          // },
          // { pattern: /^1\d{10}$/,
          //   message: '请输入正确的手机号码',
          //   trigger: 'blur'
          // }],
          liaisonName: [{
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }],
          liaisonPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          { pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: '请输入正确的电话号码（座机号格式：010-88888888）',
            trigger: 'blur'
          }],
          administrativeRegion: [{
            required: true,
            message: '请选择所属行政区',
            trigger: 'change'
          }],
          groupName: [{
            required: true,
            message: '请输入集团名称',
            trigger: 'blur'
          }],
          outsourcingPeopleNum: [{
            required: true,
            message: '请输入外委公司总人数（人）',
            trigger: 'blur'
          }],
          serviceItemsPeopleNum: [{
            required: true,
            message: '请输入服务项目人员总数（人）,',
            trigger: 'blur'
          }],
          noServiceItemsPeopleNum: [{
            required: true,
            message: '请输入不服务项目人员总数（人）',
            trigger: 'blur'
          }],
          hasParty: [{
            required: true,
            message: '请选择是否建立党组织',
            trigger: 'change'
          }],
          partyType: [{
            required: true,
            message: '请选择党组织类型',
            trigger: 'change'
          }],
          foundDate: [{
            required: true,
            message: '请选择党组织成立时间',
            trigger: 'change'
          }],
          leader: [{
            required: true,
            message: '请输入党组织负责人',
            trigger: 'blur'
          }],
          partyMemberNum: [{
            required: true,
            type: 'integer',
            message: '请输入党员总数（正整数）',
            trigger: 'blur'
          }],
          committeeMemberNum: [{
            required: true,
            type: 'integer',
            message: '请输入委员总数（正整数）',
            trigger: 'blur'
          }],
          // businessLicensePhoto: [{
          //   required: true,
          //   message: '请上传营业执照照片',
          //   trigger: 'change'
          // }],
          // businessLicensePhotoIn: [{
          //   required: true,
          //   message: '请上传法人身份证照片（正面）',
          //   trigger: 'change'
          // }],
          // businessLicensePhotoOut: [{
          //   required: true,
          //   message: '请上传法人身份证照片（背面）',
          //   trigger: 'change'
          // }],
        },
        ruleForm: {
          creditCode: '', // 社会统一信用代码
          enterpriseName: '', // 企业名称
          enterpriseSimpleName: '', // 企业简称
          logonAddress: '', // 注册地址
          communicationAddress: '', // 通讯地址
          legalPersonName: '', // 企业法人名称
          legalPersonPapersType: '', // 法人证件类型
          legalPersonPapersNum: '', // 法人证件号码
          legalPersonPhoneNum: '', // 法人手机号码
          enterpriseWebsite: '', // 企业网址
          enterpriseType: '', // 企业类型
          liaisonName: '', // 联系人
          liaisonPhone: '', // 联系电话
          email: '', // 电子信箱
          registerMoney: 0, // 注册资本
          enterpriseDate: '', // 企业成立日期
          businessLicenseDate1: '', // 营业执照开始日期
          businessLicenseDate2: '', // 营业执照截止日期
          administrativeRegion: '', // 所属行政区
          postalCode: '', // 邮政编码
          groupName: '', // 集团名称
          outsourcingPeopleNum: '', // 外委公司总人数（人）
          serviceItemsPeopleNum: '', // 服务项目人员总数（人）,
          noServiceItemsPeopleNum: '', // 不服务项目人员总数（人）,
          hasParty: '', // 是否建立党组织
          partyType: '', // 党组织类型
          foundDate: '', // 党组织成立时间
          leader: '', // 党组织负责人
          partyMemberNum: 0, // 党员总数
          committeeMemberNum: 0, // 委员总数
          businessScope: '', // 经营范围
          remark: '', // 备注
          businessLicensePhoto: '',
          businessLicensePhotoIn: '',
          businessLicensePhotoOut: '',

        },
        // 人员基本信息
        tableData: [], // 新闻list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
      }
    },
    components: {
      'upload-file': UploadFile
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.partyMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.partyMemberNum = a - 0
        }
      },
      'ruleForm.committeeMemberNum': function (a, b) {
        if (!isNaN(parseFloat(a))) {
          this.ruleForm.committeeMemberNum = a - 0
        }
      },
      'ruleForm.aaa': function (a, b) {
        console.log(a)
      }
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      let isBack = localStorage.getItem('isBack')
      localStorage.removeItem('isBack')
      if (isBack) {
        this.tabIndex = 1
        this.activeTabName = '1'
      }
      this.getFormData()
    },
    methods: {
      // 删除营业执照照片
      removeFile1(e) {
        this.isDisabled = false
        this.ruleForm.businessLicensePhoto = ''
        this.businessLicensePhotoList = []
      },
      // 删除法人身份证照片（正面）
      removeFile2(e) {
        this.isDisabled = false
        this.ruleForm.businessLicensePhotoIn = ''
        this.businessLicensePhotoInList = []
      },
      // 删除法人身份证照片（背面）
      removeFile3(e) {
        this.isDisabled = false
        this.ruleForm.businessLicensePhotoOut = ''
        this.businessLicensePhotoOutList = []
      },
      // 营业执照照片
      getBusinessLicensePhoto(e) {
        console.log(e)
        this.ruleForm.businessLicensePhoto = e
      },
      // 法人身份证照片（正面）
      getBusinessLicensePhotoIn(e) {
        console.log(e)
        this.ruleForm.businessLicensePhotoIn = e
      },
      // 法人身份证照片（背面）
      getBusinessLicensePhotoOut(e) {
        console.log(e)
        this.ruleForm.businessLicensePhotoOut = e
      },
      // 切换tab
      handleClick(tab) {
        if (tab.index == 1 && this.formId == '') {
          this.tabIndex = 0
          this.activeTabName = '0'
          this.$message({
            type: 'info',
            message: '请先保存企业基本信息'
          })
        } else {
          this.tabIndex = tab.index
        }
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取详情数据
      getFormData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawCompanyCpcOrg?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.creditCode = res.list[0].creditCode
                this.ruleForm.enterpriseName = res.list[0].enterpriseName
                this.ruleForm.enterpriseSimpleName = res.list[0].enterpriseSimpleName
                this.ruleForm.enterpriseSimpleName = res.list[0].enterpriseSimpleName
                this.ruleForm.logonAddress = res.list[0].logonAddress
                this.ruleForm.communicationAddress = res.list[0].communicationAddress
                this.ruleForm.legalPersonName = res.list[0].legalPersonName
                this.ruleForm.legalPersonPapersType = res.list[0].legalPersonPapersType
                this.ruleForm.legalPersonPapersNum = res.list[0].legalPersonPapersNum
                this.ruleForm.legalPersonPhoneNum = res.list[0].legalPersonPhoneNum
                this.ruleForm.enterpriseWebsite = res.list[0].enterpriseWebsite
                this.ruleForm.enterpriseType = res.list[0].enterpriseType
                this.ruleForm.liaisonName = res.list[0].liaisonName
                this.ruleForm.liaisonPhone = res.list[0].liaisonPhone
                this.ruleForm.email = res.list[0].email
                this.ruleForm.registerMoney = res.list[0].registerMoney
                this.ruleForm.enterpriseDate = res.list[0].enterpriseDate
                this.ruleForm.businessLicenseDate1 = res.list[0].businessLicenseDate1
                this.ruleForm.businessLicenseDate2 = res.list[0].businessLicenseDate2
                this.ruleForm.administrativeRegion = res.list[0].administrativeRegion
                this.ruleForm.postalCode = res.list[0].postalCode
                this.ruleForm.groupName = res.list[0].groupName
                this.ruleForm.outsourcingPeopleNum = res.list[0].outsourcingPeopleNum
                this.ruleForm.serviceItemsPeopleNum = res.list[0].serviceItemsPeopleNum
                this.ruleForm.noServiceItemsPeopleNum = res.list[0].noServiceItemsPeopleNum
                this.ruleForm.hasParty = res.list[0].hasParty
                this.ruleForm.partyType = res.list[0].partyType
                this.ruleForm.foundDate = res.list[0].foundDate
                this.ruleForm.leader = res.list[0].leader
                this.ruleForm.partyMemberNum = res.list[0].partyMemberNum
                this.ruleForm.committeeMemberNum = res.list[0].committeeMemberNum
                this.ruleForm.businessScope = res.list[0].businessScope
                this.ruleForm.remark = res.list[0].remark
                this.ruleForm.businessLicensePhoto = res.list[0].businessLicensePhoto
                this.ruleForm.businessLicensePhotoIn = res.list[0].businessLicensePhotoIn
                this.ruleForm.businessLicensePhotoOut = res.list[0].businessLicensePhotoOut
                this.formId = res.list[0].id
                let arr1 = []
                let arr2 = []
                let arr3 = []
                arr1.push({
                  name: '',
                  url: res.list[0].businessLicensePhoto
                })
                arr2.push({
                  name: '',
                  url: res.list[0].businessLicensePhotoIn
                })
                arr3.push({
                  name: '',
                  url: res.list[0].businessLicensePhotoOut
                })
                this.businessLicensePhotoList = arr1[0].url ? arr1 : []
                this.businessLicensePhotoInList = arr2[0].url ? arr2 : []
                this.businessLicensePhotoOutList = arr3[0].url ? arr3 : []
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
                this.getTableData()
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            this.$post('/gardenDrawCompanyCpcOrg', params).then(
              res => {
                loading.close()
                console.log(res)
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isDisabled = true
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.ruleForm.creditCode = ''
        this.ruleForm.enterpriseName = ''
        this.ruleForm.enterpriseSimpleName = ''
        this.ruleForm.enterpriseSimpleName = ''
        this.ruleForm.logonAddress = ''
        this.ruleForm.communicationAddress = ''
        this.ruleForm.legalPersonName = ''
        this.ruleForm.legalPersonPapersType = ''
        this.ruleForm.legalPersonPapersNum = ''
        this.ruleForm.legalPersonPhoneNum = ''
        this.ruleForm.enterpriseWebsite = ''
        this.ruleForm.enterpriseType = ''
        this.ruleForm.liaisonName = ''
        this.ruleForm.liaisonPhone = ''
        this.ruleForm.email = ''
        this.ruleForm.registerMoney = 0
        this.ruleForm.enterpriseDate = ''
        this.ruleForm.businessLicenseDate1 = ''
        this.ruleForm.businessLicenseDate2 = ''
        this.ruleForm.administrativeRegion = ''
        this.ruleForm.postalCode = ''
        this.ruleForm.groupName = ''
        this.ruleForm.outsourcingPeopleNum = ''
        this.ruleForm.serviceItemsPeopleNum = ''
        this.ruleForm.noServiceItemsPeopleNum = ''
        this.ruleForm.hasParty = ''
        this.ruleForm.partyType = ''
        this.ruleForm.foundDate = ''
        this.ruleForm.leader = ''
        this.ruleForm.partyMemberNum = 0
        this.ruleForm.committeeMemberNum = 0
        this.ruleForm.businessScope = ''
        this.ruleForm.remark = ''
        this.ruleForm.businessLicensePhoto = ''
        this.ruleForm.businessLicensePhotoIn = ''
        this.ruleForm.businessLicensePhotoOut = ''
        this.businessLicensePhotoList = []
        this.businessLicensePhotoInList = []
        this.businessLicensePhotoOutList = []
      },
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // ----------------------------------------------------------------------------------------
      // 人员基本信息-获取列表数据
      getTableData() {
        let loading = this.$loading()
        this.$get(
          `/gardenDrawCompanyPerson?companyId=${this.formId}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
          ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 新增人员基本信息
      add() {
        this.$router.push({
          name: 'addPropertyEnterprisePeopleInfo',
          query: {
            formId: this.formId,
            flag: false
          }
        })
      },
      // 编辑人员基本信息
      edit(rowData) {
        this.$router.push({
          name: 'addPropertyEnterprisePeopleInfo',
          query: {
            formId: this.formId,
            rowData: rowData,
            flag: true
          }
        })
      },
      // 删除人员
      deleteOne(id) {
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$delete(`/gardenDrawCompanyPerson/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getTableData()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTableData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTableData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },

    },
  }
</script>

<style lang="scss">
  .propertyEnterpriseInfo {
    .flexBox {
      display: flex;

      .el-tabs {
        background-color: #fff !important;
        flex: 1;
      }

      .el-tabs__nav-wrap {
        // width: 99%!important;
        position: static !important;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:nth-last-child(2) {
        padding-left: 20px !important;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:last-child {
        padding-right: 20px !important;
      }
    }

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>